module.exports = __webpack_public_path__ + "assets/traffic.3ba3b95f.svg";